import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { forms as Forms, buttons as Buttons } from '@breezeway/brzw-components';

import './form_control_select.scss';

const { LINK } = Buttons.constants.BUTTON_THEMES;
const isCreatedValue = (value, options) => _.findIndex(options, { value });

const FormControlSelect = ({
  className,
  clearable,
  creatable,
  creatableText,
  disabled,
  fieldRemovable,
  id,
  input: { onChange, value },
  label,
  meta: { touched, error, warning },
  options,
  placeholder,
  required,
  searchable,
  shouldShowTextError,
}) => {
  const withError = touched && (error || warning) ? error : null;
  const onSelect = option => {
    onChange(option.value);
  };

  let selectOptions = options;
  if (creatable && value && isCreatedValue(value, options)) {
    selectOptions = [...selectOptions, { value, label: value }];
  }

  return (
    <div className="form-control-select">
      <div className="form-control-select__container">
        <div className="form-control-select__select">
          <Forms.Select
            className={className}
            creatable={creatable}
            creatableText={creatableText}
            disabled={disabled}
            id={id}
            isRequired={required}
            labelText={label}
            onSelect={onSelect}
            options={selectOptions}
            placeholderText={placeholder}
            searchable={searchable}
            value={value}
            withClearAction={clearable}
            withError={withError}
          />
        </div>
        {fieldRemovable && (
          <Buttons.IconButton
            className="form-control-select__button"
            iconName="trash-o"
            onClick={fieldRemovable}
            theme={LINK}
          />
        )}
      </div>
      {shouldShowTextError && withError && (
        <span className="form-control-select__error">{error}</span>
      )}
    </div>
  );
};

FormControlSelect.propTypes = {
  className: PropTypes.string,
  clearable: PropTypes.bool,
  creatable: PropTypes.bool,
  creatableText: PropTypes.string,
  disabled: PropTypes.bool,
  fieldRemovable: PropTypes.func,
  id: PropTypes.string,
  input: PropTypes.shape({}),
  label: PropTypes.string,
  meta: PropTypes.shape({}),
  options: PropTypes.arrayOf(PropTypes.shape({})),
  placeholder: PropTypes.string,
  required: PropTypes.bool,
  searchable: PropTypes.bool,
  shouldShowTextError: PropTypes.bool,
};

FormControlSelect.defaultProps = {
  className: '',
  clearable: false,
  creatable: false,
  disabled: false,
  options: [],
  searchable: false,
};

export default FormControlSelect;
